import React from 'react';
import { getUrl } from '~helpers/getters';

export default function customeData(page) {
  const refUrl = getUrl(page?.path) || process.env.BACOM_REF_URL;
  const refName =
    getUrl(`${page?.path.replace('https://', '')}-optinmonster`) || process.env.BACOM_REF_NAME;
  function getPageMarket(marketData) {
    const market = marketData.market ? marketData.market.split('_') : '';
    return market.length > 0 ? market[0] : market;
  }
  return (
    <>
      <script type="text/javascript">
        {`
          function popUpLink(baseUrl) {
            const currentParams = new URLSearchParams(window.location.search);
            
            // Map original keys to custom ones
            const keyMap = {
              gclid: 'google_click_id',
              msclkid: 'microsoft_click_id',
              fbclid: 'facebook_click_id'
            };

            const trackingParams = [];

            Object.keys(keyMap).forEach(originalKey => {
              const value = currentParams.get(originalKey);
              if (value) {
                const mappedKey = keyMap[originalKey];
                trackingParams.push(mappedKey + '=' + encodeURIComponent(value));
              }
            });

            if (trackingParams.length > 0) {
              const separator = baseUrl.includes('?') ? '&' : '?';
              baseUrl += separator + trackingParams.join('&');
            }

            window.open(baseUrl, '_blank');
          }


          function sendEmail() {
            const allElements = document.querySelectorAll('[id^=rebel_]');
            const paramObj = [];
            for (let i = 0; i < allElements.length; i++) {
              paramObj.push(allElements[i].id.split('_')[1] + '=' + allElements[i].value)
            }
            

            // Fetch the user's IP address
            fetch('https://api.ipify.org?format=json')
              .then(response => response.json())
              .then(data => {
                const userIP = data.ip;
                var xhr = new XMLHttpRequest();
                xhr.open('GET', 'https://subscribe.${
                  process.env.GATSBY_SITE_NAME
                }/subscribe/leads/' +
                        '?country=' + encodeURIComponent('${
                          process.env.COUNTRY || getPageMarket(page).toUpperCase()
                        }') + 
                        '&ref_name=' + encodeURIComponent('${refName}') +
                        '&ref_url=' + encodeURIComponent('${refUrl}') +
                        '&timestamp=' + Math.floor(Date.now() / 1000) +
                        '&user_ip=' + userIP +
                        '&' + paramObj.join('&'), true);

                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        if (xhr.responseText === "FAIL") {
                            console.log("fail");
                        } else {
                            console.log("success");
                        }
                    }
                };

                xhr.send();
                })
              .catch(error => {
                console.error('Error fetching IP address:', error);
                // Handle the error, e.g., send the request without the IP address or show an error message
              });
          }`}
      </script>
    </>
  );
}
